import { environment } from '../environments/environment';

/** Loaded by gstatic compat scripts in index.html (avoids bundler resolution issues with firebase/*). */
type FirebaseCompat = {
  apps: { length: number };
  initializeApp: (config: typeof environment.firebase) => void;
  /** Compat: callable `firestore()` plus `firestore.FieldValue`. */
  firestore: ((app?: unknown) => CompatFirestore) & {
    FieldValue: { serverTimestamp: () => unknown };
  };
};

type CompatFirestore = {
  collection: (path: string) => { add: (data: Record<string, unknown>) => Promise<unknown> };
};

let firebaseGlobal: FirebaseCompat | null = null;
let schoolFirestoreInstance: CompatFirestore | null = null;

/** Call from main.ts before bootstrap so Firestore is ready for DI. */
export function initFirebaseCompat(): void {
  const w = window as unknown as { firebase?: FirebaseCompat };
  if (!w.firebase) {
    console.error(
      'Firebase compat SDK not found on window. Ensure firebase-app-compat.js and firebase-firestore-compat.js load in index.html.',
    );
    return;
  }
  firebaseGlobal = w.firebase;
  if (!firebaseGlobal.apps.length) {
    firebaseGlobal.initializeApp(environment.firebase);
  }
  schoolFirestoreInstance = firebaseGlobal.firestore();
}

export function getSchoolFirestore(): CompatFirestore {
  if (!schoolFirestoreInstance) {
    throw new Error('Firestore not initialized. Check Firebase scripts and initFirebaseCompat().');
  }
  return schoolFirestoreInstance;
}

export function serverTimestamp(): unknown {
  if (!firebaseGlobal) {
    throw new Error('Firebase not initialized.');
  }
  return firebaseGlobal.firestore.FieldValue.serverTimestamp();
}

